async function bulkImportExcelRequest(url = '', data = {}, apiKey, isReassessmentsAllowed = false, ignoreExistingHabitats = false, signal) {
  const response = await fetch(`${url}?isReassessmentsAllowed=${isReassessmentsAllowed}&ignoreExistingHabitats=${ignoreExistingHabitats}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'x-api-key': apiKey
      //'Content-Type': 'multipart/form-data; boundary=MyBoundary'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: data,
    signal
  })

  return response
}

export default bulkImportExcelRequest
